import React, { Component, PropTypes } from 'react';
import { push } from 'react-router-redux';
import trailingSlashIt from 'trailing-slash-it';
import TabbedNavigation from 'common/components/tabbed_navigation';

export default class YourEntries extends Component {
  constructor(props) {
    super(props);

    this.redirectIfNeeded = this.redirectIfNeeded.bind(this);
  }

  redirectIfNeeded() {
    const { router, tabs, location } = this.props;

    /* redirect to first child route if at root */
    if (trailingSlashIt(location.pathname).endsWith('/your-entries/')) {
      router.replace(tabs.links[0].url);
    }
  }

  componentDidMount() {
    this.redirectIfNeeded();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.redirectIfNeeded();
    }
  }

  render() {
    const { tabs, router, children } = this.props;

    return (
      <div className="your-entries">
        { tabs.links.length > 1 &&
        <div className="row">
          <div className="small-16 columns">
            <h3>All Entries</h3>
            <TabbedNavigation {...{ router, tabs, push }} />
          </div>
        </div> }

        { children }
      </div>
    );
  }
};

YourEntries.propTypes = {
  tabs: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./profile/components/your_entries/index.jsx